import Moment from 'moment';

import { FetchAPI, ParamsSerializer } from './auth-service';

const fields = [
    // we'll have to add datetime controls on the page to allow date filtering
    {
        variable: 'created',
        hidden: false,
        hiddenByColumnsButton: true,
        title: 'Time',
        field: 'created',
        defaultSort: 'desc',
        type: 'str',
        flexDefault: 0.5,
        filter: false,
    },
    {
        variable: 'source',
        hidden: false,
        hiddenByColumnsButton: true,
        title: 'Source',
        field: 'source',
        type: 'str',
        flexDefault: 0.75,
        filter: true,
    },
    {
        variable: 'host',
        hidden: false,
        hiddenByColumnsButton: true,
        title: 'Host',
        field: 'data.host',
        type: 'str',
        flexDefault: 0.5,
        filter: true,
    },
    {
        variable: 'actor',
        hidden: false,
        hiddenByColumnsButton: true,
        title: 'User',
        field: 'data.actor',
        type: 'str',
        flexDefault: 0.5,
        filter: true,
    },
    {
        variable: 'action',
        hidden: false,
        hiddenByColumnsButton: true,
        title: 'Action',
        field: 'data.action',
        type: 'str',
        flexDefault: 3,
        cellStyle: {
            textOverflow: 'ellipsis',
            whitespace: 'nowrap',
            overflow: 'hidden',
            maxWidth: 200,
        },
        filter: true,
    },
    {
        variable: 'subject',
        hidden: false,
        hiddenByColumnsButton: true,
        title: 'Subject',
        field: 'subject',
        type: 'str',
        filter: true,
    },
    {
        variable: 'result',
        hidden: false,
        hiddenByColumnsButton: true,
        title: 'Result',
        field: 'result',
        type: 'str',
        flexDefault: 0.75,
        filter: true,
    },
];

class AuditDataService {
    constructor () {
        if (!AuditDataService.instance) {
            AuditDataService.instance = this;
        }
        this.searchPlaceholder = 'Search audit trails';
        this.fields = fields;
        this.controller = null;

        this.getData = ({ search, filter, sort, offset, limit, start, end }) => {
            // abort previous request
            this.controller && this.controller.abort();
            this.controller = new AbortController();

            const params = {
                filter: `${filter}=${search}`,
                sort: sort || 'createddesc',
                limit: limit || 50,
                offset: offset || 0,
                start_time: start ? start.utc().toISOString() : undefined,
                end_time: end ? end.utc().toISOString() : undefined,
            };
            return FetchAPI({
                method: 'GET',
                url: `audittrails/?${ParamsSerializer(params)}`,
                signal: this.controller ? this.controller.signal : undefined,
            }).then(res => {
                if (!res) res = { objects: [] };
                self.asof = res.timestamp;
                this.data = res.objects || [];

                return {
                    data: this.data,
                    totalCount: this.total || (res.objects || []).length,
                };
            });
        };

        this.getSavedSearches = () => {
            try {
                let searches = localStorage.getItem('savedSearches_audit') || '[]';
                if (searches.length < 1) searches = '[]';
                return JSON.parse(searches);
            } catch (err) {
                console.log('getSavedSearches error', err);
                return [];
            }
        };

        this.saveSearch = (str) => {
            if (!str || !str.length) return;
            const searches = this.getSavedSearches();
            const i = searches.findIndex(s => s === str);
            if (i >= 0) searches.splice(i, 1);
            searches.unshift(str);
            searches.splice(5);
            localStorage.setItem('savedSearches_audit', JSON.stringify(searches));
        };

        this.generateReport = ({
            sort = '',
            search = '',
            filter = 'all',
            format = 'csv',
            report_type = 'audit',
            start,
            end
        } = {}) => {
            const params = {
                sort: `${sort}`,
                filter: `${filter}=${search}`,
                format: `${format}`,
                report_type: `${report_type}`,
                start_time: start ? start.utc().toISOString() : undefined,
                end_time: end ? end.utc().toISOString() : undefined,
            };

            return FetchAPI({
                method: 'POST',
                url: `system/reports/audit/?${ParamsSerializer(params)}`
            }).then(res => {
                let f = '';
                switch (format) {
                    case 'csv':
                        f = 'text/csv';
                        break;
                    case 'html':
                        f = 'text/html';
                        break;
                    default:
                        f = 'text/plain';
                        break;
                }

                return URL.createObjectURL(new Blob([res], { type: `${f}` }), `report-${Moment().format('MM/DD/YY-HH:mm:ss')}.${format === 'rst' ? 'txt' : format}`);
            });
        };

        this.cancelAll = () => {
            this.controller && this.controller.abort();
        };

        return AuditDataService.instance;
    }
}

const AuditService = new AuditDataService();

export {
    AuditService as default,
    fields
};
